<template>
    <el-container>
        <el-header id="header">
            <Header :menu-collapse="menuCollapse"></Header>
        </el-header>
        <el-container class="aside-main" :style="'padding-top:' + asideMainHeight + 'px'">
            <el-aside width="auto">
                <!--菜单导航-->
                <side-bar :menu-collapse="menuCollapse"></side-bar>
            </el-aside>
            <el-main id="appMain">
                <div class="shadow" id="shadow" :style="'width:' + toolsWidth + 'px'">
                    <!--控制菜单显隐-->
                    <div class="menu-switch" @click="menuCollapse = !menuCollapse">
                        <i v-if="menuCollapse" class="el-icon-s-unfold"></i>
                        <i v-else class="el-icon-s-fold"></i>
                    </div>
                    <!--路径导航-->
                    <breadcrumb id="breadcrumb"></breadcrumb>
                    <!--tabs标签页-->
                    <tabs id="tabs"></tabs>
                </div>
                <!--页面显示-->
                <app-main :style="'margin-top:' + toolsHeight + 'px'"></app-main>
            </el-main>
        </el-container>
        <el-backtop target="#appMain"/>
    </el-container>
</template>

<script>
    import Header from "@/components/header/Header";
    import SideBar from "@/components/sidebar/SideBar";
    import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
    import Tabs from "@/components/tabs/Tabs";
    import AppMain from "@/components/appmain/AppMain";
    import erd from "element-resize-detector";
    import store from "@/store";
    import PubSub from "pubsub-js";

    export default {
        name: "LayOut",
        components: {Header, SideBar, Breadcrumb, Tabs, AppMain},
        data(){
            return{
                menuCollapse: false,
                asideMainHeight: 60,
                toolsWidth: '',
                toolsHeight: 79,
                websocket: null,
                timer: null
            }
        },
        mounted(){
            erd().listenTo(document.getElementById("header"), element => {
                this.$nextTick(() => {
                    //监听到事件后执行的业务逻辑
                    this.asideMainHeight = element.clientHeight
                });
            });
            erd().listenTo(document.getElementById("appMain"), element => {
                this.$nextTick(() => {
                    //监听到事件后执行的业务逻辑
                    this.toolsWidth = element.offsetWidth;
                });
            });
            erd().listenTo(document.getElementById("shadow"), element => {
                this.$nextTick(() => {
                    //监听到事件后执行的业务逻辑
                    this.toolsHeight = element.clientHeight;
                });
            });
            //this.initWebSocket();
        },
        beforeDestroy() {
            if (this.timer){
                clearInterval(this.timer);
            }
            this.websocket && this.websocket.close();
        },
        computed: {
        },
        methods: {
            initWebSocket(){ //初始化weosocket
                if (!this.websocket && store.state.username){
                    const wsUri = "ws://localhost:20001/websocket/" + store.state.username;
                    console.log("wsUri " + wsUri);
                    this.websocket = new WebSocket(wsUri);
                    this.websocket.onmessage = this.websocketOnMessage;
                    this.websocket.onopen = this.websocketOnOpen;
                    this.websocket.onerror = this.websocketOnError;
                    this.websocket.onclose = this.websocketOnClose;
                }
            },
            websocketOnOpen(){ //连接建立之后执行send方法发送数据
                //let actions = {"test":"12345"};
                //this.websocketSend(JSON.stringify(actions));
                console.log("websocket连接成功");
                this.timer = setInterval(this.heartHandler,5000);
            },
            websocketOnError(){//连接建立失败重连
                this.initWebSocket();
            },
            websocketOnMessage(e){ //数据接收
                const reData = JSON.parse(e.data);
                console.log(reData.action);
                if (reData.action == 'heartHandler'){  // 心跳
                    //PubSub.publish("refreshOrder"); // 刷新订单
                }else if (reData.action == 'refreshOperationLog'){  // 刷新操作日志
                    PubSub.publish("refreshOperationLog");
                }else if (reData.action == 'refreshErrorLog'){  // 刷新错误日志
                    PubSub.publish("refreshErrorLog");
                }
            },
            websocketSend(data){//数据发送
                this.websocket.send(data);
            },
            websocketOnClose(e){  //关闭
                console.log('断开连接',e);
            },
            heartHandler(){
                this.websocketSend("heartHandler")
            }
        }
    }
</script>

<style scoped>
    .el-container {
        width: 100%;
        height: 100%;
    }
    .el-header {
        height: auto!important;
        padding: 0 10px;
        background-color: #1f2d3d !important;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        line-height: 100%;
        position: fixed;
        flex-direction: column;
        width: 100%;
        z-index: 100;
    }
    .el-aside {
        background-color: rgb(48, 65, 86);
    }
    .el-main {
        padding: 0;
    }
    .aside-main {
        padding-top: 60px;
    }

    .menu-switch{
        position: absolute;
        margin: 0 50px 0 0;
        width: 40px;
        height: 40px;
        text-align: center;
        /*background-color: #1f2d3d;
        color: #FFFFFF;*/
    }
    .menu-switch:hover {
        background: rgba(0, 0, 0, 0.05);
    }
    .menu-switch i{
        font-family: element-icons!important;
        cursor: pointer;
        font-size: 23px;
        height: 100%;
        line-height: 40px;
    }
    .shadow {
        position: fixed!important;
        background: #FFFFFF;
        z-index: 99;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
    /*#breadcrumb {
        position: absolute;
        width: 100%;
        background: #FFFFFF;
        z-index: 100;
        !*margin-top: 40px;*!
    }
    #tabs {
        position: absolute;
        width: 100%;
        background: #FFFFFF;
        z-index: 100;
        margin-top: 40px;
    }*/
</style>
